<div class="widget-card up-2 widget-{{widget()?.color}} bg-background on-background">
  @switch (widget()?.type) {
    @case (wType.PRODUCTIVITE_MOYENNE) {
      <vl-widget-productivite-moyenne [metadata]="metaData()()" [data]="widgetData()?.data.data" [widget]="widget()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-productivite-moyenne>
    }
    @case (wType.OF_EN_COURS) {
      <vl-widget-of-en-cours [data]="widgetData()?.data.data" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-of-en-cours>
    }
    @case (wType.HEURES_TRAVAILLES) {
      <vl-widget-heures-travailles [data]="widgetData()?.data.data" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-heures-travailles>
    }
    @case (wType.QUANTITE_OF) {
      <vl-widget-quantite-of [data]="widgetData()?.data.data" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-quantite-of>
    }
    @case (wType.OF_LIST) {
      <vl-widget-of-list [data]="widgetData()?.data.data" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-of-list>
    }
    @case (wType.CADENCE_REELLE) {
      TODO
    }
    @case (wType.QUANTITE_PRODUITE_PERIODE) {
      <vl-widget-quantite-produite-periode [data]="widgetData()?.data.data" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-quantite-produite-periode>
    }
    @case (wType.CA_CUMULE) {
      <vl-widget-ca-cumule [data]="widgetData()?.data.data" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-ca-cumule>
    }
    @case (wType.CA_PAR_PERIODE) {
      <vl-widget-ca-par-periode [data]="widgetData()?.data.data" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-ca-par-periode>
    }
    @case (wType.REPARTITION_PAR_CLIENT) {
      <vl-widget-repartition-par-client [data]="widgetData()?.data.data" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-repartition-par-client>
    }
    @case (wType.CA_N_MOINS_1) {
      <vl-widget-ca-nmoins [data]="widgetData()?.data.data" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-ca-nmoins>
    }
    @case (wType.CA_DELTA) {
      <vl-widget-ca-delta [data]="widgetData()?.data.data" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-ca-delta>
    }
    @case (wType.LOT_PAR_ETAT) {
      <vl-widget-lot-par-etat [data]="widgetData()?.data.data" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-lot-par-etat>
    }
    @case (wType.VALEUR_PAR_FAMILLE) {
      <vl-widget-valeur-par-famille [data]="widgetData()?.data.data" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-valeur-par-famille>
    }
    @case (wType.EVOLUTION_VALEUR) {
      <vl-widget-evolution-valeur [widget]="widget()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-evolution-valeur>
    }
    @case (wType.COMMANDE_FOURNISSEUR_LIST) {
      <vl-commande-fournisseur-list [data]="widgetData()?.data.data" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-commande-fournisseur-list>
    }
    @case (wType.SPECIFICATION_LIST) {
      <vl-specification-list [data]="widgetData()?.data.data" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-specification-list>
    }
    @case (wType.COMMANDE_CLIENT_LIST) {
      <vl-widget-commande-client-list [data]="widgetData()?.data.data" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-commande-client-list>
    }
    @case (wType.QUICK_WIN) {
      <vl-quick-win-scatter class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-quick-win-scatter>
    }
    @case (wType.CONSOS_PAR_ARTICLE) {
      <vl-consos-par-article class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-consos-par-article>
    }
    @case (wType.PRODUCTIONS) {
      <vl-of-productions-table class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-of-productions-table>
    }
    @case (wType.ACHATS) {
      <vl-achats-par-fournisseur class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-achats-par-fournisseur>
    }
    @case (wType.ACHATS_EVOLUTION) {
      <vl-stats-achat-evolution class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-stats-achat-evolution>
    }
    @case (wType.VENTES) {
      <vl-repartition-ca-article class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-repartition-ca-article>
    }
    @case (wType.MARGE) {
      <vl-repartition-ca-article class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-repartition-ca-article>
    }
    @case (wType.CA_CUMULE_ARTICLE) {
      <vl-ca-cumule-article class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-ca-cumule-article>
    }
    @case (wType.CA_PERIODE_ARTICLE) {
      <vl-widget-ca-par-periode-article class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-ca-par-periode-article>
    }
    @case (wType.MOUVEMENTS_ARTICLES) {
      <vl-mouvements-synthese class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-mouvements-synthese>
    }
    @case (wType.STOCKS_ARTICLE) {
      <vl-stock-kpis class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-stock-kpis>
    }
    @case (wType.HEURES_OFS) {
      <vl-heures-par-user class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-heures-par-user>
    }
    @case (wType.MARGE_TIERS) {
      <vl-repartition-ca-tiers class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-repartition-ca-tiers>
    }
    @case (wType.CA_CUMULE_TIERS) {
      <vl-ca-cumule-tiers class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-ca-cumule-tiers>
    }
    @case (wType.CA_PAR_PERIODE_TIERS) {
      <vl-widget-ca-par-periode-tiers class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-ca-par-periode-tiers>
    }
    @case (wType.ACHATS_EVOLUTION_TIERS) {
      <vl-stats-achat-evolution-tiers class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-stats-achat-evolution-tiers>
    }
    @case (wType.VENTE_EVOLUTION_TIERS) {
      <vl-stats-vente-evolution-tiers class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-stats-vente-evolution-tiers>
    }
    @case (wType.ACHATS_TIERS) {
      <vl-achats-articles-par-tiers class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-achats-articles-par-tiers>
    }
    @case (wType.VENTES_TIERS) {
      <vl-repartition-ca-tiers class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-repartition-ca-tiers>
    }
    @case (wType.QUANTITE_PRODUITE_LIGNE) {
      <vl-widget-quantite-produite-ligne class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-quantite-produite-ligne>
    }
    @case (wType.MAIN_OEUVRE_LIGNE) {
      <vl-widget-main-oeuvre-ligne class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-main-oeuvre-ligne>
    }
    @case (wType.PRODUCTIVITE_LIGNE) {
      <vl-widget-productivite-ligne class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-productivite-ligne>
    }
    @case (wType.COUTS_LIGNE) {
      <vl-widget-couts-ligne class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-couts-ligne>
    }
    @case (wType.OFS_LIGNE) {
      <vl-widget-ofs-ligne class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-ofs-ligne>
    }
    @case (wType.ARTICLES_PRODUITS_LIGNE) {
      <vl-widget-articles-produits-ligne class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-articles-produits-ligne>
    }
    @case (wType.HEURES_USER_INFOS) {
      <vl-widget-heures-user-infos class="h100" [widget]="widget()" [metadata]="metaData()()" [editable]="editable()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-heures-user-infos>
    }
    @case (wType.REPARTITION_TRAVAIL_USER_INFOS) {
      <vl-widget-repartition-travail-user-infos class="h100" [widget]="widget()" [metadata]="metaData()()" [editable]="editable()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-repartition-travail-user-infos>
    }
    @case (wType.OFS_USER_INFOS) {
      <vl-widget-ofs-user-infos class="h100" [widget]="widget()" [metadata]="metaData()()" [editable]="editable()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-ofs-user-infos>
    }
    @case (wType.PRODUCTIVITE_USER_INFOS) {
      <vl-widget-productivite-user-infos class="h100" [widget]="widget()" [metadata]="metaData()()" [editable]="editable()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-productivite-user-infos>
    }
    @case (wType.LIGNES_USER_INFOS) {
      <vl-widget-lignes-user-infos class="h100" [widget]="widget()" [metadata]="metaData()()" [editable]="editable()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-lignes-user-infos>
    }
    @case (wType.ARTICLES_PRODUITS_USER_INFOS) {
      <vl-widget-articles-produits-user-infos class="h100" [widget]="widget()" [metadata]="metaData()()" [editable]="editable()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-articles-produits-user-infos>
    }
    @case (wType.PLANNING) {
      <vl-widget-planning class="h100" [widget]="widget()" [metadata]="metaData()()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-planning>
    }
    @case (wType.NC_STATS) {
      <!-- Self-fetching : le widget gère sa période (1M/3M/6M/1A) et appelle
           directement non_conformites/stats + analytics. Pas de [data] ni
           [metadata] — cf. widget-container.component.ts skip. -->
      <vl-widget-nc-stats [widget]="widget()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-nc-stats>
    }
    @case (wType.NC_CLOSURE_METRICS) {
      <!-- Self-fetching : timeScale (vl-widget-period-filters) + endpoint
           non_conformites/closure_metrics. Pas de [data]/[metadata]. -->
      <vl-widget-nc-closure-metrics [widget]="widget()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-nc-closure-metrics>
    }
    @case (wType.NC_SUPPLIER_COMPLIANCE) {
      <!-- Self-fetching : timeScale (vl-widget-period-filters) + endpoint
           non_conformites/supplier_compliance. Pas de [data]/[metadata]. -->
      <vl-widget-nc-supplier-compliance [widget]="widget()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-nc-supplier-compliance>
    }
    @case (wType.LIVE_PRODUCTION) {
      <!-- Self-fetching : LiveProductionService gère son propre polling REST 5s
           (snapshot agrégé) et expose un signal `lignes()`. Pas de [data]/[metadata]. -->
      <vl-widget-live-production [widget]="widget()">
        <ng-container [ngTemplateOutlet]="handler" class="drag-handler"></ng-container>
      </vl-widget-live-production>
    }
  }


</div>

<ng-template #handler>
  @if (editable()) {
    <ng-content select='.drag-handler'></ng-content>
  }
</ng-template>

